export default __webpack_public_path__ + "static/media/SoguiLogoBlackAndPinkWithSoftLaunch.c5c09d83.png";